<template>
    <div class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm margem">
            <fieldset class="grid-2">
                <div>
                    <label>Responsável</label>
                    <select v-model="novaTarefa.responsavel_id" :required="!novaTarefa.responsavel_id">
                        <option :value="null" hidden>-</option>
                        <option v-for="u in propUsuarios" :key="u.id" :value="u.id">{{ u.nomeCompleto }}</option>
                        <!-- :hidden="!propSubordinados.includes(u.id)" -->
                    </select>
                </div>
                <div>
                    <label>Sprint</label>
                    <select v-model="novaTarefa.sprint_id" :required="!novaTarefa.sprint_id">
                        <option :value="null" hidden>-</option>
                        <option v-for="s in propSprints" :value="s.id" :key="s.id" :hidden="s.nome == 'Backlogs'">{{
                            s.nome }}</option>
                    </select>
                </div>
                <div class="col-2">
                    <label>Descrição</label>
                    <textarea v-model="novaTarefa.descricao" :required="!novaTarefa.descricao"></textarea>
                </div>
                <div>
                    <label>Início Previsto</label>
                    <input type="date" v-model="novaTarefa.dtInicio" :required="!novaTarefa.dtInicio">
                </div>
                <div>
                    <label>Fim Previsto</label>
                    <input type="date" v-model="novaTarefa.dtFim" :required="!novaTarefa.dtFim">
                </div>
                <div class="col-2">
                    <label>Observações</label>
                    <textarea v-model="novaTarefa.obs"></textarea>
                </div>
            </fieldset>
            <div class="submit direita">
                <button class="acao-secundaria" @click="$emit('fechar')">Cancelar</button>
                <button :disabled="camposVazios" @click="criarTarefa()">Criar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { datasPrevistasDaSprint } from '@/utils/sprintGestao';

export default {
    name: 'ModalCriarTarefa',

    props: {
        propHistoria: {
            required: true
        },
        propSprints: {
            required: true
        },
        propUsuarios: {
            required: true
        },
        propSubordinados: {
            required: true
        }
    },

    computed: {
        camposVazios() {
            var campos = ['responsavel_id', 'sprint_id', 'descricao', 'dtInicio', 'dtFim'];

            return campos.some(item => !this.novaTarefa[item]);
        }
    },

    data() {
        return {
            novaTarefa: {
                parente_id: null,
                sprint_id: null,
                dtInicio: null,
                dtFim: null,
            },
        }
    },

    watch: {
        'novaTarefa.sprint_id'(id) {
            this.preencherDatasDaSprint(id);
        },
    },

    methods: {
        criarTarefa() {
            this.$emit('criarTarefa', this.novaTarefa)
        },
        preencherDatasDaSprint(sprintId) {
            if (!sprintId) return;
            const sprint = this.propSprints.find((s) => s.id === sprintId);
            if (!sprint || sprint.nome === 'Backlogs') return;
            const { inicio, fim } = datasPrevistasDaSprint(sprint);
            this.novaTarefa.dtInicio = inicio;
            this.novaTarefa.dtFim = fim;
        },
    },

    mounted() {
        this.novaTarefa.parente_id = this.propHistoria.id;
        const sprintAtiva = this.propSprints.find(
            (s) => s.nome !== 'Backlogs' && s.dtInicio && s.dtTermino
        );
        if (sprintAtiva) {
            this.novaTarefa.sprint_id = sprintAtiva.id;
            this.preencherDatasDaSprint(sprintAtiva.id);
        }
    },
}
</script>

<style scoped>
.jm {
    max-width: 70vw;
    max-height: 80vh;
    overflow: auto;
}
</style>